// CONTAINER
import TableContainer from './TableContainer';

// TOOLS
import AssignmentCell from './tools/AssignmentCell';
import BooleanCell from './tools/BooleanCell';
import CodeCell from './tools/CodeCell';
import ColumnsFilter from './tools/ColumnsFilter';
import DateCell from './tools/DateCell';
import DateTimeCell from './tools/DateTimeCell';
import DollarsCell from './tools/DollarsCell';
import ExternalLinkCell from './tools/ExternalLinkCell';
import LinkCell from './tools/LinkCell';
import ListCell from './tools/ListCell';
import NumberCell from './tools/NumberCell';
import TableBadge from './tools/TableBadge';
import TableDnD from './types/DnDContainer';
import TableFilters from './tools/TableFilters';
import TableSorted from './types/SortedContainer';
import TimesCell from './tools/TimesCell';
import TradeCell from './tools/TradeCell';

// MAIN COMPONENT
const Table = TableContainer;

// TYPES
Table.DnD = TableDnD;
Table.Sorted = TableSorted;

// TOOLS
Table.Assignment = AssignmentCell;
Table.Badge = TableBadge;
Table.Boolean = BooleanCell;
Table.Code = CodeCell;
Table.Columns = ColumnsFilter;
Table.Date = DateCell;
Table.DateTime = DateTimeCell;
Table.Dollars = DollarsCell;
Table.ExternalLink = ExternalLinkCell;
Table.Link = LinkCell;
Table.List = ListCell;
Table.Number = NumberCell;
Table.Times = TimesCell;
Table.Trade = TradeCell;
export const Filters = TableFilters;

// EXPORT
export default Table;
